import { IntlShape, MessageDescriptor } from 'react-intl';
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import { Options as IntlMessageFormatOptions } from 'intl-messageformat/src/core';

class LanguageUtil {
  static intl: IntlShape;

  static setIntl = (intl: IntlShape) => {
    LanguageUtil.intl = intl;
  };

  public static get = (
    descriptor: MessageDescriptor,
    values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>,
    opts?: IntlMessageFormatOptions,
  ): string => {
    return LanguageUtil.intl.formatMessage(descriptor, values, opts);
  };

  public static errorWithName = (type: string, component: string) => {
    const _component = LanguageUtil.get({
      id: `component.${component}.name`,
      defaultMessage: component,
    });

    const _type = LanguageUtil.get({
      id: `operation-types.${type}`,
      defaultMessage: type,
    });

    return LanguageUtil.get(
      {
        id: 'error.an.error.name',
        defaultMessage: `There is an error happened while ${_type} ${_component.toLowerCase()}`,
      },
      { name: _component.toLowerCase, type: _type.toLowerCase() },
    );
  };

  public static alreadyExist = (component: string, name: string) => {
    const _component = LanguageUtil.get({
      id: `component.${component}.name`,
      defaultMessage: component,
    });

    return LanguageUtil.get(
      {
        id: 'error.already.exist',
        defaultMessage: `${_component} [${name}] already exist`,
      },
      { component: _component, name },
    );
  };

  public static inappropriateCharacters = () => {
    return LanguageUtil.get({
      id: 'error.inappropriate.characters',
      defaultMessage: 'You used inappropriate characters',
    });
  };

  public static fieldsAreNotValid = () => {
    return LanguageUtil.get({ id: 'error.fields.not.valid', defaultMessage: 'Please fill in the required fields according to the rules' });
  };
}

export default LanguageUtil;
